import React, { useEffect, useState } from 'react'
import { useQuery, OperationVariables } from '@apollo/client'
import Typography from '@material-ui/core/Typography'
import { remove } from 'local-storage'
import { useUserDispatcher } from '@hooks'
import appClient from '@services'
import { DashboardInfoContainer, RowItem } from './index.sc'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getActiveUsers } from '../../services/restAPI/user/userService'
import { getActiveLearners } from '../../services/restAPI/learner/learnerService'

const useImperativeQuery = (query: any, client: any) => {
    const { refetch } = useQuery(query, { client, skip: true })

    const imperativelyCallQuery = (variables: Partial<OperationVariables> | undefined) => {
        return refetch(variables)
    }

    return imperativelyCallQuery
}

const Dashboard: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { clearUserAuthData } = useUserDispatcher()
    const [users, setUsers] = useState<any[]>([])
    const [learners, setLearners] = useState<any[]>([])

    const goToLogin = () => {
        remove('token')
        clearUserAuthData()
    }

    const retrieveDashboardInfo = async () => {
        Promise.all([getActiveUsers(), getActiveLearners()])
            .then(response => {
                const [users, learners] = response
                setUsers(users)
                setLearners(learners)
            })
            .catch(err => {
                if (err.message == "authorization") {
                    goToLogin()
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        retrieveDashboardInfo()
    }, [])

    const renderRowItem = (label: string, total?: number) => {
        return <RowItem>
            <div>{label}</div>
            <div>{isLoading ? <CircularProgress size={15} /> : total ?? '-'}</div>
        </RowItem>
    }

    return <div>
        <Typography paragraph style={{
            border: '1px solid #dedede',
            padding: '20px',
            borderRadius: '5px',
            background: '#fff',
        }}>
            <p style={{ fontSize: 20, textAlign: 'center' }}>Welcome to <strong>Admin Portal</strong> for Parenteque Learn.</p>
            <DashboardInfoContainer>
                <h3>User</h3>
                {renderRowItem('Total', users.length)}

                <h3>Learner</h3>
                {renderRowItem('Total', learners.length)}

                {/* NOTES: HIDE IT FOR NOW DUE TO THIS INFORMATION SEEMS DUPLICATE, ADMIN CAN ACCESSES THIS INFO VIA GOOGLE PLAY STORE OR APPLE STORE */}
                {/* <h3>Subscription</h3>
                {renderRowItem('Total Active Premium Users', dashboardInfo?.totalActivePremiumUsers)}

                <ul>
                    <li>
                        {renderRowItem('Total Monthly Subscriptions', dashboardInfo?.totalActiveMonthlyUsers)}
                    </li>
                    <li>
                        {renderRowItem('Total Yearly Subscriptions', dashboardInfo?.totalActiveYearlyUsers)}
                    </li>
                </ul>

                {renderRowItem('Total Active Additional Slot Subscriptions', dashboardInfo?.totalActiveAdditionalSlotUsers)} */}
            </DashboardInfoContainer>
        </Typography>
    </div >
}

export default Dashboard